import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useUrlParameterFromRegex } from "@edreamsodigeo/frontend-core";
const useGetActionsFromUrl = () => {
  const tokenRegex = new RegExp(/.*actions=([^^,;:%?&]+).*?$/);
  const [, action] = useUrlParameterFromRegex(tokenRegex);
  return action;
};
export default useGetActionsFromUrl;